import { render, staticRenderFns } from "./VisorServicio.vue?vue&type=template&id=329d8869&"
import script from "./VisorServicio.vue?vue&type=script&lang=js&"
export * from "./VisorServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports